<template>
  <form id="donation-payment" class="card w-modal h-modal">
    <div class="header">
      <div class="title">
        <div class="flex flex-col">
          <h1 class="mb-2">New Donation</h1>
          <div class="flex flex-row">
            <h4 class="opacity-50">Supporter Details</h4>
            <h4 class="ml-4 mr-4 opacity-50">></h4>
            <h4 class="opacity-50">Donation Details</h4>
            <h4 class="ml-4 mr-4">></h4>
            <h4>Payment</h4>
          </div>
        </div>
      </div>
      <div class="close" @click="close()">
        <i class="icn icn-x sm"></i>
      </div>
    </div>
    <div class="content" v-show="!isLoadingPayment">
      <div class="mb-5 mt-5 flex flex-row items-center">
        <img class="w-24" src="@/assets/img/secure-icon.svg" />
        <div class="flex flex-col ml-2 uppercase">
          <div class="font-bold">Secure</div>
          <div>Payment</div>
        </div>
      </div>
      <div v-if="payload.donation.paymentType === creditCard">
        <h2>Credit Card Details</h2>
        <bambora-credit-card-form
          :key="bamboraFormKey"
          @startProcessingPayment="isLoadingPayment = true"
          @finishProcessingPayment="isLoadingPayment = false"
          @success="processDonation"
          @error="onError"
        ></bambora-credit-card-form>
      </div>
      <div v-if="payload.donation.paymentType === directDebit">
        <h2>Bank Account Details</h2>
        <bambora-direct-debit-form
          :key="bamboraFormKey"
          @startProcessingPayment="isLoadingPayment = true"
          @finishProcessingPayment="isLoadingPayment = false"
          @success="processDonation"
        ></bambora-direct-debit-form>
      </div>
      <alert v-if="errorMessage" :message="errorMessage" class="mt-4"></alert>
    </div>
    <div class="content" v-show="isLoadingPayment">
      <div class="flex flex-col items-center">
        <img class="h-40 mb-14 mt-20" src="@/assets/img/loading.svg" />
        <div class="flex flex-col items-center">
          <h1 class="mb-10">Processing The Payment</h1>
          <h1>Do not navigate</h1>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!isLoadingPayment">
      <button class="secondary" type="button" @click="$emit('previousStep')">Back</button>
      <div class="flex-grow"></div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import BamboraCreditCardForm from './BamboraCreditCardForm';
import BamboraDirectDebitForm from './BamboraDirectDebitForm';
import Alert from '@/components/Alert.vue';

export default {
  name: 'DonationPayment',
  components: {
    BamboraCreditCardForm,
    BamboraDirectDebitForm,
    Alert,
  },

  data() {
    return {
      bamboraFormKey: 0,
      isLoadingPayment: false,
      errorMessage: null,
      creditCard: 'wwf_purchasetokenise',
      directDebit: 'wwf_directdebit',
    };
  },
  computed: {
    ...mapState({
      payload: (state) => state.donationModal.payload,
    }),
  },

  methods: {
    close() {
      this.$store.dispatch('donationModal/close');
      this.$store.dispatch('donationModal/reset');
    },
    onError() {
      if (this.payload.donation.paymentType == this.creditCard) {
        this.errorMessage = {
          content: 'The credit card information is not correct. Try another card.',
          type: 'error',
        };
      } else {
        this.errorMessage = {
          content: 'The bank account information is not correct. Try another account.',
          type: 'error',
        };
      }
      this.bamboraFormKey += 1;
    },
    async processDonation(responseData) {
      try {
        this.isLoadingPayment = true;
        if (this.payload.donation.paymentType == this.creditCard) {
          this.payload.paymentInformation = {
            accountNumber: null,
            accountRouting: null,
            accountTitle: null,
            creditCardToken: responseData.token,
            creditCardHolderName: responseData.cardHolderName,
          };
        } else {
          this.payload.paymentInformation = {
            accountNumber: responseData.accno,
            accountRouting: responseData.accrouting,
            accountTitle: responseData.acctitle,
            creditCardToken: null,
            creditCardHolderName: null,
          };
        }

        this.payload.transaction = await this.$store.dispatch(
          'donationModal/createDonationAndProcessPayment',
          this.payload,
        );
        // this.$store.dispatch('dotp/getAll');

        if (this.payload.transaction.status === 'failed') {
          this.payload.paymentInformation = {
            accountNumber: null,
            accountRouting: null,
            accountTitle: null,
            creditCardToken: null,
            creditCardHolderName: null,
          };

          if (this.payload.donation.paymentType == this.creditCard) {
            this.errorMessage = {
              content: 'The credit card information is not correct. Try another card.',
              type: 'error',
            };
          } else {
            this.errorMessage = {
              content: 'The bank account information is not correct. Try another account.',
              type: 'error',
            };
          }
          this.bamboraFormKey += 1;
        } else {
          this.$emit('nextStep');
          this.errorMessage = null;
          // this.$store.dispatch('dotp/getAll');
        }
      } catch (err) {
        console.log(err);
        this.errorMessage = {
          content: 'Payment server is unable to process transaction. Please try again later.',
          type: 'error',
        };
        this.bamboraFormKey += 1;
      } finally {
        this.isLoadingPayment = false;
      }
    },
  },
};
</script>

<style>
input[type='text'] {
  @apply placeholder-gray-400;
}
</style>
